import { Unit_instancev9v8hjid95df as Unit_instance } from '../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { fromInt2ii0rejb1w62w as fromInt } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/internal/longAsBigInt/longAsBigInt.mjs';
import {
  awaitContent$default2jefvu0cvwa0w as awaitContent$default,
  ByteReadChannel2wzou76jce72d as ByteReadChannel,
} from './ByteReadChannel.mjs';
import { protoOf180f3jzyo7rfj as protoOf } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { IOException1wyutdmfe71nu as IOException } from '../../../../../kotlinx-io-kotlinx-io-core/kotlinx/io/-PlatformJs.mjs';
import { CloseToken4utf44psnuyc as CloseToken } from './CloseToken.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var SourceByteReadChannelClass;
function SourceByteReadChannel() {
  if (SourceByteReadChannelClass === VOID) {
    class $ {
      constructor(source) {
        this.d4l_1 = source;
        this.e4l_1 = null;
      }
      y4i() {
        var tmp0_safe_receiver = this.e4l_1;
        return tmp0_safe_receiver == null ? null : tmp0_safe_receiver.z4i();
      }
      a4j() {
        return this.d4l_1.s3x();
      }
      t4i() {
        var tmp0_safe_receiver = this.y4i();
        if (tmp0_safe_receiver == null)
          null;
        else {
          // Inline function 'kotlin.let' call
          throw tmp0_safe_receiver;
        }
        return this.d4l_1.r3x();
      }
      *b4j(min, $completion) {
        var tmp0_safe_receiver = this.y4i();
        if (tmp0_safe_receiver == null)
          null;
        else {
          // Inline function 'kotlin.let' call
          throw tmp0_safe_receiver;
        }
        return this.d4l_1.y3x(fromInt(min));
      }
      l4j(cause) {
        if (!(this.e4l_1 == null))
          return Unit_instance;
        this.d4l_1.l6();
        var tmp = this;
        var tmp1_elvis_lhs = cause == null ? null : cause.message;
        tmp.e4l_1 = new (CloseToken())(IOException().m4h(tmp1_elvis_lhs == null ? 'Channel was cancelled' : tmp1_elvis_lhs, cause));
      }
    }
    protoOf($).h4j = awaitContent$default;
    initMetadataForClass($, 'SourceByteReadChannel', VOID, VOID, [ByteReadChannel()], [1]);
    SourceByteReadChannelClass = $;
  }
  return SourceByteReadChannelClass;
}
//region block: exports
export {
  SourceByteReadChannel as SourceByteReadChannel1ruj5s0fyiukm,
};
//endregion

//# sourceMappingURL=SourceByteReadChannel.mjs.map
